import { createSlice } from '@reduxjs/toolkit'
import name from './name'

export const onboarding = createSlice({
  name,
  initialState: {
    playlistPopperOpen: false,
    myLearningBadge: false,
    myLearningFeedback: false,
    homeEnterprisePopperOpen: false,
    onboarding: {}
  },
  reducers: {
    setOnboardingProfile: (state, { payload }) => {
      state.playlistPopperOpen = payload.onboarding.playlists.show && !payload.onboarding.playlists.onboarded
      state.onboarding = {
        ...payload
      }
      state.homeEnterprisePopperOpen = payload.onboarding.homeEnterprise.show && !payload.onboarding.homeEnterprise.onboarded
      state.myLearningBadge = payload.onboarding.myLearning.show && !payload.onboarding.myLearning.onboarded
      state.myLearningFeedback = payload.onboarding.myLearningFeedback.show && !payload.onboarding.myLearningFeedback.onboarded
    },
    openPlaylistPopper: (state) => {
      state.playlistPopperOpen = false
    },
    closePlaylistPopper: (state) => {
      state.playlistPopperOpen = false
    },
    closeHomeEnterprisePopper: (state) => {
      state.onboarding.onboarding.homeEnterprise.show = false
      state.homeEnterprisePopperOpen = false
    },
    removeMyLearningBadge: (state) => {
      state.myLearningBadge = false
    },
    dismissMyLearningFeedback: (state) => {
      state.myLearningFeedback = false
    }
  }
})

export const { setOnboardingProfile, openPlaylistPopper, closeHomeEnterprisePopper, closePlaylistPopper, removeMyLearningBadge, dismissMyLearningFeedback } = onboarding.actions

export default onboarding.reducer
